import React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Link } from "@jsq/ds/core";

export const CellLinkRenderer = (params: ICellRendererParams) => {
  if (!params.value) return null;

  const { id, name } = params.value as { id: number; name: string };
  return (
    <Link icon="external-link" iconPosition="right" align="left" to={`/compliance/case/${id}`}>
      {name}
    </Link>
  );
};
